import { render, staticRenderFns } from "./ModaleSavedNodes.vue?vue&type=template&id=3aa8a58d&scoped=true&"
import script from "./ModaleSavedNodes.vue?vue&type=script&lang=js&"
export * from "./ModaleSavedNodes.vue?vue&type=script&lang=js&"
import style0 from "./ModaleSavedNodes.vue?vue&type=style&index=0&id=3aa8a58d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa8a58d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VDivider,VHover,VRow,VSpacer,VSystemBar})
